import { render, staticRenderFns } from "./PdfPreview.vue?vue&type=template&id=dbbd9e5a&scoped=true"
import script from "./PdfPreview.vue?vue&type=script&lang=js"
export * from "./PdfPreview.vue?vue&type=script&lang=js"
import style0 from "./PdfPreview.vue?vue&type=style&index=0&id=dbbd9e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbd9e5a",
  null
  
)

export default component.exports